import { createApp } from 'vue';
import App from './Login.vue';

import '@av/themes/element-plus/index.scss';
import '@av/themes/whitelabels/index.scss';

const app = createApp(App);

app.mount('#login');